var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUltrasoundNoImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 121,
    viewBox: "0 0 180 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M134.7 4.42578C107.315 14.7116 79.9304 14.7116 52.5458 4.42578L8.04578 83.2835C25.1612 103.855 55.9689 120.998 93.6227 120.998C131.277 120.998 162.084 103.855 179.2 83.2835L134.7 4.42578Z",
    fill: "#9FBCA5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M134.7 4.42578C107.315 14.7116 79.9304 14.7116 52.5458 4.42578L8.04578 83.2835C25.1612 103.855 55.9689 120.998 93.6227 120.998C131.277 120.998 162.084 103.855 179.2 83.2835L134.7 4.42578Z",
    fill: "#9FBCA5",
    fillOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M134.7 4.42578C107.315 14.7116 79.9304 14.7116 52.5458 4.42578L8.04578 83.2835C25.1612 103.855 55.9689 120.998 93.6227 120.998C131.277 120.998 162.084 103.855 179.2 83.2835L134.7 4.42578Z",
    fill: "#9FBCA5",
    fillOpacity: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M134.7 4.42578C107.315 14.7116 79.9304 14.7116 52.5458 4.42578L8.04578 83.2835C25.1612 103.855 55.9689 120.998 93.6227 120.998C131.277 120.998 162.084 103.855 179.2 83.2835L134.7 4.42578Z",
    fill: "#9FBCA5",
    fillOpacity: 0.2
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M123.031 36.2113C111.886 30.9279 99.427 34.8972 94.6281 44.0916L81.9553 47.1275C81.2932 44.4666 79.6109 41.2413 77.0398 39.3776C68.7949 33.366 58.6268 37.5496 58.6268 37.5496C58.3263 35.7171 56.4862 34.3811 54.5043 34.5438L53.6757 34.6018C49.8604 34.9102 47.2053 37.9465 47.5589 41.4899C48.0706 46.5631 49.6525 53.0706 54.1765 54.6603L55.5536 56.3419C50.1673 59.7349 45.8687 65.1965 44.9336 71.3143C44.0295 77.2451 47.8933 83.771 52.7241 87.7742C58.022 92.1833 64.9641 94.5639 71.8594 95.5144C84.4348 97.2645 97.7323 94.6342 107.479 87.7218C111.102 85.165 114.205 81.9926 116.307 78.2226C116.35 78.1353 116.557 77.603 116.842 76.8681C116.98 76.5127 117.136 76.11 117.302 75.6872C117.932 74.0008 119.459 72.7927 121.339 72.2759C128.548 70.2815 134.23 64.6915 135.266 56.9159C136.38 48.6716 131.334 40.1614 123.031 36.2113Z",
    fill: "#EAF0F0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M127.853 0.998047C100.469 11.2838 73.0842 11.2838 45.6996 0.998047L1.19958 79.8557C18.315 100.427 49.1227 117.57 86.7765 117.57C124.43 117.57 155.238 100.427 172.353 79.8557L127.853 0.998047Z",
    stroke: "#1A1A1A",
    strokeWidth: 1.50002,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M127.853 0.998047C100.469 11.2838 73.0842 11.2838 45.6996 0.998047L1.19958 79.8557C18.315 100.427 49.1227 117.57 86.7765 117.57C124.43 117.57 155.238 100.427 172.353 79.8557L127.853 0.998047Z",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.50002,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M127.853 0.998047C100.469 11.2838 73.0842 11.2838 45.6996 0.998047L1.19958 79.8557C18.315 100.427 49.1227 117.57 86.7765 117.57C124.43 117.57 155.238 100.427 172.353 79.8557L127.853 0.998047Z",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.50002,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M127.853 0.998047C100.469 11.2838 73.0842 11.2838 45.6996 0.998047L1.19958 79.8557C18.315 100.427 49.1227 117.57 86.7765 117.57C124.43 117.57 155.238 100.427 172.353 79.8557L127.853 0.998047Z",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.50002,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M97.0117 45.1919C101.701 38.129 110.43 33.9461 119.878 36.0033C127.991 37.7519 134.529 44.3348 136.24 52.4948C139.184 66.5521 128.572 78.9293 115.051 78.9293C115.051 78.9293 107.829 97.0323 75.3094 97.0323C60.4533 97.0323 40.5309 91.4437 40.3256 73.4093C40.2913 69.9807 40.9759 66.5178 42.7217 63.5692C47.1032 56.232 57.304 52.5977 64.9375 49.992",
    stroke: "#1A1A1A",
    strokeWidth: 1.50002,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M97.0117 45.1919C101.701 38.129 110.43 33.9461 119.878 36.0033C127.991 37.7519 134.529 44.3348 136.24 52.4948C139.184 66.5521 128.572 78.9293 115.051 78.9293C115.051 78.9293 107.829 97.0323 75.3094 97.0323C60.4533 97.0323 40.5309 91.4437 40.3256 73.4093C40.2913 69.9807 40.9759 66.5178 42.7217 63.5692C47.1032 56.232 57.304 52.5977 64.9375 49.992",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.50002,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M97.0117 45.1919C101.701 38.129 110.43 33.9461 119.878 36.0033C127.991 37.7519 134.529 44.3348 136.24 52.4948C139.184 66.5521 128.572 78.9293 115.051 78.9293C115.051 78.9293 107.829 97.0323 75.3094 97.0323C60.4533 97.0323 40.5309 91.4437 40.3256 73.4093C40.2913 69.9807 40.9759 66.5178 42.7217 63.5692C47.1032 56.232 57.304 52.5977 64.9375 49.992",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.50002,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M97.0117 45.1919C101.701 38.129 110.43 33.9461 119.878 36.0033C127.991 37.7519 134.529 44.3348 136.24 52.4948C139.184 66.5521 128.572 78.9293 115.051 78.9293C115.051 78.9293 107.829 97.0323 75.3094 97.0323C60.4533 97.0323 40.5309 91.4437 40.3256 73.4093C40.2913 69.9807 40.9759 66.5178 42.7217 63.5692C47.1032 56.232 57.304 52.5977 64.9375 49.992",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.50002,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7766 52.4297C90.1997 55.8583 90.1997 62.7155 90.1997 62.7155C90.1997 62.7155 97.0458 62.7155 100.469 69.5727",
    stroke: "#1A1A1A",
    strokeWidth: 1.50002,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7766 52.4297C90.1997 55.8583 90.1997 62.7155 90.1997 62.7155C90.1997 62.7155 97.0458 62.7155 100.469 69.5727",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.50002,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7766 52.4297C90.1997 55.8583 90.1997 62.7155 90.1997 62.7155C90.1997 62.7155 97.0458 62.7155 100.469 69.5727",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.50002,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7766 52.4297C90.1997 55.8583 90.1997 62.7155 90.1997 62.7155C90.1997 62.7155 97.0458 62.7155 100.469 69.5727",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.50002,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5072 66.1445V69.5731C76.5072 75.2646 81.0941 79.8589 86.7764 79.8589",
    stroke: "#1A1A1A",
    strokeWidth: 1.50002,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5072 66.1445V69.5731C76.5072 75.2646 81.0941 79.8589 86.7764 79.8589",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.50002,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5072 66.1445V69.5731C76.5072 75.2646 81.0941 79.8589 86.7764 79.8589",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.50002,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5072 66.1445V69.5731C76.5072 75.2646 81.0941 79.8589 86.7764 79.8589",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.50002,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4924 71.6645L73.7347 64.7045C78.082 61.4473 81.334 56.7501 82.3266 51.4015C82.4293 50.9215 82.4978 50.4072 82.532 49.9272C82.8059 46.8758 81.7447 41.87 78.9036 39.0586C71.6809 31.8242 62.7466 35.2528 62.7466 35.2528V31.8242H57.3382C53.7782 31.8242 50.6974 34.7385 50.492 38.3043C50.1839 43.9614 49.602 51.3329 54.052 53.5615",
    stroke: "#1A1A1A",
    strokeWidth: 1.50002,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4924 71.6645L73.7347 64.7045C78.082 61.4473 81.334 56.7501 82.3266 51.4015C82.4293 50.9215 82.4978 50.4072 82.532 49.9272C82.8059 46.8758 81.7447 41.87 78.9036 39.0586C71.6809 31.8242 62.7466 35.2528 62.7466 35.2528V31.8242H57.3382C53.7782 31.8242 50.6974 34.7385 50.492 38.3043C50.1839 43.9614 49.602 51.3329 54.052 53.5615",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.50002,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4924 71.6645L73.7347 64.7045C78.082 61.4473 81.334 56.7501 82.3266 51.4015C82.4293 50.9215 82.4978 50.4072 82.532 49.9272C82.8059 46.8758 81.7447 41.87 78.9036 39.0586C71.6809 31.8242 62.7466 35.2528 62.7466 35.2528V31.8242H57.3382C53.7782 31.8242 50.6974 34.7385 50.492 38.3043C50.1839 43.9614 49.602 51.3329 54.052 53.5615",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.50002,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4924 71.6645L73.7347 64.7045C78.082 61.4473 81.334 56.7501 82.3266 51.4015C82.4293 50.9215 82.4978 50.4072 82.532 49.9272C82.8059 46.8758 81.7447 41.87 78.9036 39.0586C71.6809 31.8242 62.7466 35.2528 62.7466 35.2528V31.8242H57.3382C53.7782 31.8242 50.6974 34.7385 50.492 38.3043C50.1839 43.9614 49.602 51.3329 54.052 53.5615",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.50002,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUltrasoundNoImage);
export default __webpack_public_path__ + "static/media/ultrasound_no_image.99ebac3aad294bc189f44a0fdafbb91f.svg";
export { ForwardRef as ReactComponent };